import { Outlet } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import SurveyQuestions from 'modules/surveys/components/Questions/SurveyQuestions'
import SurveyShowHeader from 'modules/surveys/components/Show/SurveyShowHeader'
import SurveyShowPageTabs from 'modules/surveys/components/Show/SurveyShowPageTabs'
import { useSurveyShowContext } from 'modules/surveys/pages/Show/hooks'
import type SurveyForm from 'modules/surveys/store/models/Form'
import type Survey from 'modules/surveys/store/models/v2/Survey'

export default function SurveyQuestionsPage() {
  const { employee } = useCurrentSession()
  const { survey, hasSurveyV2, form, canEditSurvey, loading } = useSurveyShowContext()
  const surveyModel = hasSurveyV2 ? (survey as Survey) : (form as SurveyForm)

  if (!survey) {
    return null
  }

  return (
    <ResponsivePage.Body
      showHeader={false}
      loading={loading}
      error={null}
      authorized={employee?.hasRegularAccess && canEditSurvey}
    >
      <Box gap="s24">
        <SurveyShowHeader survey={survey} canEditSurvey={canEditSurvey} />
        <SurveyShowPageTabs form={survey} canEditSurvey={canEditSurvey} />
      </Box>

      <SurveyQuestions form={surveyModel} />
      <Outlet context={{ form }} />
    </ResponsivePage.Body>
  )
}
